import { Progress } from 'flowbite-react';
import React from 'react';

interface Props {
	progress: number;
}

const BannerRightSection = ({ progress }: Props) => {
	return (
		<div className="mt-[auto]">
			<div className="flex items-center justify-between">
				<p className="text-[12px] md:text-[16px] font-[500] leading-[10px] dark:text-[#C7C9D9] text-[#28293D] font-inter ">
					Overall Progress
				</p>
				<p className="text-[10px] md:text-[16px] font-[500] leading-[10px] dark:text-[#fff] text-[#555770] font-inter ">{`${progress}%`}</p>
			</div>
			<div className="mt-[12px] md:w-[348px]">
				<Progress
					theme={{
						base: 'w-full overflow-hidden rounded-full !bg-[#EBEBF0] dark:bg-[#C7C9D9]',
					}}
					progress={progress}
					color="purplePlaced"
					className="prepare-banner-progress-bar rounded-[8px] progress-bar md:mt-2 "
				/>
			</div>
		</div>
	);
};

export default BannerRightSection;
